import * as React from 'react';
import { observer } from 'mobx-react';
import { BatchListMainViewModel } from './batch-list-main-view-model';
import { BatchList } from '../../components/batch-list/batch-list';
import { SvgWrapper } from '../../../components/svg-wrapper';
import { BatchListUserAction } from './batch-list-user-actions';
import { RenderResponsive } from '../../../components/hoc-behavior/render-responsive';
import { ResponsiveVisibility, ResponsiveBreakpoint } from '../../../helpers/responsive-helper';
import { classNames } from '../../../../Shared/utils/classnames';
import { BatchListSagaContext, getActionHandlers } from './batch-list-saga';
import { runVirtualTerminalSaga } from '../../saga/virtual-terminal-saga';
import { Fragment } from '../../../../Shared/components/fragment';
import { BatchEntryIntro } from '../../components/batch-entry-intro';
import { StorageHelper } from '../../../helpers/storagehelper';

import * as styles from './batch-list-main.less';

interface IBatchListMainProps {
	vm: BatchListMainViewModel;
}

const CreateButton: React.StatelessComponent<{cssClassNames: string, url: string}> = (props) => {
	const { url, cssClassNames } = props;

	return (
		<a className={classNames('btn', 'btn-sm', 'btn-link', cssClassNames)} href={url} data-pp-at-target="create batch">
			<SvgWrapper svg="icon-add" className="icon" /> Create batch
		</a>
	);
};

@observer
export class BatchListMain extends React.Component<IBatchListMainProps, {}> {
	constructor(props: IBatchListMainProps) {
		super(props);
		const { vm } = props;
		const batchListSagaContext = new BatchListSagaContext(vm);

		runVirtualTerminalSaga(batchListSagaContext, getActionHandlers());

		vm.setUserActionChannel(batchListSagaContext.userActionChannel);
		vm.userActionChannel.put(new BatchListUserAction.QueryBatches());
	}

	componentDidMount() {
		//Clean up any expired default settings from local storage
		window.setTimeout(StorageHelper.cleanupExpiredDefaultSettings, 0);
	}

	render() {
		const { CreateBatchUrl, HelpCenterUrl, PaymentLabel: { NounPluralLowerCase } } = this.props.vm.viewData;

		return (
			<Fragment>
				<header className={styles.header}>
					<h1 className={styles.title}>Batch Entry</h1>
					<RenderResponsive visibility={ResponsiveVisibility.Visible} breakpoints={ResponsiveBreakpoint.Md|ResponsiveBreakpoint.Lg}>
						<CreateButton url={CreateBatchUrl} cssClassNames={`pull-right ${styles.buttonCreateDesktop}`} />
					</RenderResponsive>
				</header>
				<BatchEntryIntro paymentNoun={NounPluralLowerCase} />
				<RenderResponsive visibility={ResponsiveVisibility.Visible} breakpoints={ResponsiveBreakpoint.Xs|ResponsiveBreakpoint.Sm}>
					<CreateButton url={CreateBatchUrl} cssClassNames={styles.buttonCreateMobile} />
				</RenderResponsive>
				<BatchList {...this.props} />
				<footer className={styles.footer}>
					Learn how to enter {NounPluralLowerCase} and create your batch <a
						className="arrow-hollow-right-after"
						href={HelpCenterUrl}
						data-pp-at-target="help center"
						target="_blank" rel="noopener noreferrer"
					>Help Center</a>
				</footer>
			</Fragment>
		);
	}
}
